import React from "react";
import { Pagination } from "antd";
import BaseComponent from "../../common/BaseComponent";
import "./index.scss";

const makeItemRender = (testid: any) => (page: any, type: any, originalElement: any) => {
  if (type === "prev") {
    return <span data-testid={testid ? `${testid}-prev` : undefined}>{"<    "}Previous</span>;
  }
  if (type === "next") {
    return <span data-testid={testid ? `${testid}-next` : undefined}>Next{"    >"}</span>;
  }
  if (type === "page") {
    return <a data-testid={testid ? `${testid}-page-${page}` : undefined}>{page}</a>;
  }
  if (type === "jump-prev") {
    return testid
      ? React.cloneElement(originalElement, { "data-testid": `${testid}-jump-prev` })
      : originalElement;
  }
  if (type === "jump-next") {
    return testid
      ? React.cloneElement(originalElement, { "data-testid": `${testid}-jump-next` })
      : originalElement;
  }
  return originalElement;
};

export default class NormalPagination extends BaseComponent {
  render() {
    const {
      current,
      disabled,
      pageSize,
      pageSizeOptions = [10, 30, 50],
      total,
      onChange,
      showTotal,
      selectComponentClass,
      testid,
    } = this.props;
    return (
      <div className="customPagination" data-testid={testid}>
        <Pagination
          current={current}
          disabled={disabled}
          pageSize={pageSize}
          pageSizeOptions={pageSizeOptions}
          total={total}
          onChange={onChange}
          showSizeChanger
          itemRender={makeItemRender(testid)}
          showTotal={showTotal}
          selectComponentClass={selectComponentClass}
        />
      </div>
    );
  }
}
